export const modalContentWithNoPaddingStyle = {
  '&.MuiDialog-root .MuiPaper-root .MuiDialogContent-root': { padding: 0 },
};

export const modalContentHorizontalPaddingSize = 40;
